module.exports = __webpack_public_path__ + "5cb451cd35913a472975254985133b6c.svg";